import React, { FC } from 'react'

import { IconMusicAndMoviesProps } from './IconMusicAndMovies.types'
import * as Styled from './styles/IconMusicAndMovies.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMusicAndMovies: FC<IconMusicAndMoviesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMusicAndMoviesProps['size'],
  isResponsive = false,
}: IconMusicAndMoviesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m29.175 38.172.015-13.815 3.573 3.71' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M25.285 42.063a3.89 3.89 0 1 0 0-7.78 3.89 3.89 0 0 0 0 7.78Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M11 15.787v11.225a4 4 0 0 0 4 4h10.285' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M11 15.787h26.225v11.225a4 4 0 0 1-4 4' stroke='#fff' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M36.39 9.215a4.013 4.013 0 0 0-4.875-2.87L13.87 10.912A4 4 0 0 0 11 15.787m0 0 25.39-6.572M11 19.932h26.225M17.22 15.787l-4.165 4.165m13.027-4.165-4.165 4.165m13.028-4.165-4.165 4.165'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMusicAndMovies
